import { render, staticRenderFns } from "./AKPayTransaction.vue?vue&type=template&id=07656804"
import script from "./AKPayTransaction.vue?vue&type=script&lang=js"
export * from "./AKPayTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports